<!-- 共享厨房面板：建设投料/运营池/灶位烹饪（选灶下锅→倒计时→领取窗）/拾取筐/扩建预告与建设（公共设施通用框架·厨房实例 v2） -->
<template>
    <div id="kitchenDiv" class="wrap">
        <el-dialog :visible.sync="kitchenVisible"
        :before-close="kitchen_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载灶台进度" element-loading-spinner="el-icon-loading"
         title="共享厨房" :close-on-click-modal="false">
            <!-- 建设中（主设施） -->
            <div v-if="detail && detail.facility && detail.facility.status === 'building'" class="kitchen-build">
                <div class="build-banner">🔥 全城合力建设中 —— 材料与金币各占一半，凑齐就能点火开张！</div>
                <div class="progress-row">
                    <span class="progress-label">全城进度</span>
                    <el-progress :percentage="Number(detail.progress.overall)" :stroke-width="16" style="flex:1"></el-progress>
                </div>
                <div class="tiny-progress">
                    材料 {{ detail.progress.materialPercent }}% ｜ 金币 {{ detail.progress.moneyPercent }}%
                </div>
                <!-- 需求与投料 -->
                <div class="require-list">
                    <div class="require-row" v-for="r in detail.requires" :key="r.id">
                        <span class="require-name">{{ r.name }}</span>
                        <span class="require-num">{{ fmtNum(r.cur) }} / {{ fmtNum(r.target) }}</span>
                        <span class="require-tag" v-if="r.poolTarget">→ {{ poolLabel(r.poolTarget) }}</span>
                        <span class="require-done" v-else-if="Number(r.cur) >= Number(r.target)">✓ 已收满</span>
                        <div class="require-input">
                            <template v-if="r.reqType === 'MATERIAL'">
                                <el-input size="small" v-model.number="contributeNum[r.id]" type="number"
                                          placeholder="投料数量" style="width:90px"></el-input>
                                <el-button size="small" type="primary" @click="doBuildContribute(r, facilityKey)">投料</el-button>
                            </template>
                            <template v-else>
                                <el-input size="small" v-model.number="moneyInput" type="number"
                                          placeholder="投料金额（元）" style="width:110px"></el-input>
                                <el-button size="small" type="warning" @click="doBuildContribute(r, facilityKey)">捐金币</el-button>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="builders-line">建设者 {{ detail.builders }} 人 ｜ 你已经投过料就是咱自己人（名录永久记名）</div>
                <div class="npc-tip">投料前请备好相应的物资；同一物资收满后不再接收。</div>
            </div>

            <!-- 运营中（主设施） -->
            <div v-else-if="detail && detail.facility && detail.facility.status === 'active'" class="kitchen-active">
                <!-- 资格横幅 -->
                <div class="qualify-banner" :class="{ok: detail.mine.qualified}">
                    <template v-if="detail.mine.qualified">
                        🍳 你是咱自己人{{ detail.mine.builder ? '（建设者，入伙线折半）' : '' }}——公共灶台随时开火！
                    </template>
                    <template v-else>
                        投过料的就是自己人——投料 <b>{{ detail.mine.needFuel }} 份燃料 或 {{ detail.mine.needIngot }} 件铁锭</b> 即可入伙
                    </template>
                </div>

                <!-- 两池水位 -->
                <div class="pool-row" v-for="p in detail.pools" :key="p.poolKey">
                    <span class="pool-name">{{ poolLabel(p.poolKey) }}</span>
                    <el-progress :percentage="poolPercent(p)" :stroke-width="14"
                                 :color="p.poolKey === 'FUEL' ? '#e6a23c' : '#67c23a'"
                                 style="flex:1"></el-progress>
                    <span class="pool-num">{{ p.curNum }} / {{ p.capacity }}</span>
                </div>
                <div class="pool-tip">燃料池空了？公共灶台免费燃料不可用，可自备燃料或投料补给；灶具耐久见底需要铁锭修复。</div>

                <!-- 运营投料 -->
                <div class="contribute-area">
                    <span class="section-title">投料补给</span>
                    <div class="contribute-row">
                        <el-input size="small" v-model.number="runFuelNum" type="number" placeholder="燃料数量" style="width:100px"></el-input>
                        <el-button size="small" type="primary" @click="doRunContribute('122')">投燃料</el-button>
                        <el-input size="small" v-model.number="runIngotNum" type="number" placeholder="铁锭数量" style="width:100px"></el-input>
                        <el-button size="small" type="primary" @click="doRunContribute('120')">投铁锭</el-button>
                    </div>
                    <div class="tiny-progress">燃料=煤炭/木块 1:1；铁锭=耐久池 1件=10点。池满也记入投料任务。</div>
                </div>

                <!-- 灶位区（占用对全服可见：烹饪内容/制作人/剩余时间） -->
                <div class="stove-area">
                    <span class="section-title">公共灶台（基础菜谱，无需铁锅；累计烹饪热度 {{ detail.opsCookTotal || 0 }}）</span>
                    <div class="stove-row" v-for="s in publicStoves" :key="s.id" :class="{mine: s.mine}">
                        <span class="stove-name">{{ s.facilityName }}·{{ s.stoveNo }}号灶</span>
                        <span class="stove-state">
                            <template v-if="s.status === 'idle'">空闲</template>
                            <template v-else-if="s.status === 'cooking'">🔥 {{ s.dishName }} · {{ s.cookUserNick || '厨友' }} · 剩 <b class="cook-cd">{{ s.remainingSeconds }}</b> 秒<template v-if="s.mine">（我的）</template></template>
                            <template v-else-if="s.status === 'claim'">🍽 {{ s.dishName }} 待领取 · 剩 <b class="cook-cd">{{ s.remainingSeconds }}</b> 秒<template v-if="s.mine">（我的）</template></template>
                        </span>
                        <el-button v-if="s.status === 'claim' && s.mine" size="mini" type="success" @click="doCollect(s)">领取</el-button>
                        <el-button v-else-if="s.status === 'idle' && selectedDish" size="mini" type="primary" plain
                                   @click="doCook(s)">用此灶下锅</el-button>
                    </div>
                    <div class="stove-tip" v-if="!publicStoves.length">灶位还没配上——等管理员在设施里添加灶位行。</div>
                    <!-- 超时未领取会进拾取筐 -->
                    <div class="my-claims-entry" v-if="detail.claimsMine > 0">
                        <el-button size="mini" type="warning" plain @click="openClaims">
                            🧺 我的拾取（{{ detail.claimsMine }}）——超时产出在这里等你领回
                        </el-button>
                    </div>
                </div>

                <!-- 菜谱选择（选中后点空闲灶下锅） -->
                <div class="cook-area">
                    <span class="section-title">选菜谱（公共灶台，无需铁锅； buff 菜绝不入单）</span>
                    <div class="fuel-source">
                        <span>燃料来源：</span>
                        <el-radio-group v-model="fuelSource" size="small">
                            <el-radio-button label="POOL">公共燃料池</el-radio-button>
                            <el-radio-button label="BAG">背包自带</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="dish-grid" v-if="detail.recipes && detail.recipes.length">
                        <div class="dish-card" v-for="d in detail.recipes" :key="d.dishBO.id"
                             @click="selectedDish = d.dishBO" :class="{active: selectedDish && selectedDish.id === d.dishBO.id}">
                            <div class="dish-name">{{ d.dishBO.name }}</div>
                            <div class="dish-effect">恢复体力 {{ d.dishBO.propertyVal }}</div>
                            <div class="dish-mat">{{ materialText(d.dishBO) }}</div>
                        </div>
                    </div>
                    <div class="tiny-progress" v-if="selectedDish">已选【{{ selectedDish.name }}】——点上方空闲灶的「用此灶下锅」开火；出锅后 60 秒内点「领取」，超时会进拾取筐（不没收）。</div>
                </div>

                <!-- 厨师工位区（占用显示；转职开放后厨师从技能面板下锅，自动分配空闲工位灶） -->
                <div class="chef-area" v-if="chefStoves.length || detail.chefTransferEnabled == 1">
                    <span class="section-title">厨师工位区{{ detail.chefTransferEnabled != 1 ? '（未开放）' : '' }}</span>
                    <div class="stove-row" v-for="s in chefStoves" :key="s.id" :class="{mine: s.mine}">
                        <span class="stove-name">{{ s.facilityName }}·{{ s.stoveNo }}号灶（工位）</span>
                        <span class="stove-state">
                            <template v-if="s.status === 'idle'">空闲</template>
                            <template v-else-if="s.status === 'cooking'">🔥 {{ s.dishName }} · {{ s.cookUserNick || '厨师' }} · 剩 <b class="cook-cd">{{ s.remainingSeconds }}</b> 秒<template v-if="s.mine">（我的）</template></template>
                            <template v-else-if="s.status === 'claim'">🍽 {{ s.dishName }} 待领取 · 剩 <b class="cook-cd">{{ s.remainingSeconds }}</b> 秒<template v-if="s.mine">（我的）</template></template>
                        </span>
                        <el-button v-if="s.status === 'claim' && s.mine" size="mini" type="success" @click="doCollect(s)">领取</el-button>
                    </div>
                    <div class="tiny-progress" v-if="detail.chefTransferEnabled == 1">厨师烹饪走技能面板（自备铁锅与燃料），自动分配空闲工位灶。</div>
                    <div class="tiny-progress" v-else>厨师的工位灶还没开张——等共享厨房稳定运营后开放厨师转职。</div>
                </div>

                <div class="buff-tip" v-if="detail.chefTransferEnabled != 1">
                    厨师的工位区还没开张——等共享厨房稳定运营后开放厨师转职（重出江湖）。
                </div>

                <!-- 扩建区（预告中/建设中） -->
                <div class="ext-area" v-if="extensionRows.length">
                    <span class="section-title">扩建动态</span>
                    <div class="ext-block" v-for="ext in extensionRows" :key="ext.facilityKey">
                        <!-- 预告中：解锁进度 -->
                        <template v-if="ext.status === 'announced'">
                            <div class="ext-title">🔮 {{ ext.facilityName }} · 预告中</div>
                            <div class="progress-row">
                                <span class="progress-label">烹饪热度</span>
                                <el-progress :percentage="unlockPercent(ext)" :stroke-width="14" color="#909399" style="flex:1"></el-progress>
                                <span class="pool-num">{{ detail.opsCookTotal || 0 }} / {{ ext.unlockTarget }}</span>
                            </div>
                            <div class="tiny-progress">全城每做一道菜热度 +1；达标自动开工，届时开放投料共建。</div>
                        </template>
                        <!-- 建设中：需求与投料（材料金币 50/50，建成并池） -->
                        <template v-else-if="ext.status === 'building'">
                            <div class="ext-title">🚧 {{ ext.facilityName }} · 建设中（全城进度 {{ Number(ext.progress.overall) }}%）</div>
                            <div class="require-row" v-for="r in ext.requires" :key="ext.facilityKey + '-' + r.id">
                                <span class="require-name">{{ r.name }}</span>
                                <span class="require-num">{{ fmtNum(r.cur) }} / {{ fmtNum(r.target) }}</span>
                                <span class="require-tag" v-if="r.poolTarget">→ 建成并入{{ poolLabel(r.poolTarget) }}</span>
                                <span class="require-done" v-else-if="Number(r.cur) >= Number(r.target)">✓ 已收满</span>
                                <div class="require-input">
                                    <template v-if="r.reqType === 'MATERIAL'">
                                        <el-input size="small" v-model.number="contributeNum[r.id]" type="number"
                                                  placeholder="投料数量" style="width:90px"></el-input>
                                        <el-button size="small" type="primary" @click="doBuildContribute(r, ext.facilityKey)">投料</el-button>
                                    </template>
                                    <template v-else>
                                        <el-input size="small" v-model.number="extMoneyInput[ext.facilityKey]" type="number"
                                                  placeholder="投料金额（元）" style="width:110px"></el-input>
                                        <el-button size="small" type="warning" @click="doBuildContribute(r, ext.facilityKey)">捐金币</el-button>
                                    </template>
                                </div>
                            </div>
                            <div class="tiny-progress">扩建建设者同样记入名录、同享老人待遇；建成时煤炭/铁锭并入主厨房两池。</div>
                        </template>
                    </div>
                </div>
            </div>

            <div v-else class="empty-tip">设施信息加载中……</div>

            <!-- 建设者名录入口：点按钮弹窗查看（组内合并；列表按贡献排序，物资仅排序不展示明细） -->
            <div class="builders-entry" v-if="detail">
                <el-button size="mini" type="text" @click="buildersVisible = true">
                    👥 建设者名录（{{ detail.builders }} 人）
                </el-button>
            </div>
        </el-dialog>

        <!-- 建设者名录弹窗 -->
        <el-dialog :visible.sync="buildersVisible" title="建设者名录" append-to-body width="420px">
            <div class="builder-row" v-for="(b, idx) in contributors" :key="b.userId">
                <span class="builder-rank">{{ idx + 1 }}</span>
                <span class="builder-name">{{ b.nickName || b.userName || b.userId }}</span>
                <span class="builder-times">投料 {{ b.buildCount }} 次</span>
            </div>
            <div v-if="!contributors || !contributors.length" class="empty-tip">暂无建设者。</div>
        </el-dialog>

        <!-- 我的拾取（拾取筐）弹窗 -->
        <el-dialog :visible.sync="claimsVisible" title="我的拾取（拾取处·灶台旁置物架）" append-to-body width="420px">
            <div class="claim-row" v-for="c in claims" :key="c.id">
                <span class="claim-name">{{ c.dishName }} ×{{ c.num }}</span>
                <span class="claim-time">{{ fmtTime(c.makeTime) }} 出锅</span>
                <el-button size="mini" type="success" @click="doTakeClaim(c)">领回</el-button>
            </div>
            <div v-if="!claims || !claims.length" class="empty-tip">拾取筐空空的——领取窗超时的产出会自动放进这里。</div>
            <div class="tiny-progress">领回后保质期从出锅时刻起算（保鲜规则照常），记得尽早吃掉。</div>
        </el-dialog>
    </div>
</template>

<script>
import { postRequest, getRequest, onResult } from '@/utils/api';
import Message from 'element-ui/lib/message'
export default {
  name: 'kitchenPanel',
  props: {
    kitchenVisible: { type: Boolean, default: false },
    facilityKey: { type: String, default: 'shared_kitchen' }
  },
  data() {
    return {
      loading: false,
      detail: null,
      contributors: [],       // 建设者名录（组内合并；物资仅排序不展示明细）
      contributeNum: {},      // {requireId: num}
      moneyInput: null,       // 主设施投金币
      extMoneyInput: {},      // {facilityKey: 金额} 扩建投金币
      runFuelNum: null,
      runIngotNum: null,
      fuelSource: 'POOL',
      selectedDish: null,
      stoves: [],             // 灶位列表（占用对全服可见）
      stoveTimer: null,       // 灶位轮询（倒计时/领取窗）
      claims: [],             // 我的拾取（拾取筐）
      claimsVisible: false,
      buildersVisible: false
    };
  },
  computed: {
    // 运营中设施的公共灶（建设中/配置中扩建的灶位不可见不可用）
    publicStoves() {
      return this.stoves.filter(s => s.area === 'PUBLIC' && s.facilityStatus === 'active');
    },
    chefStoves() {
      return this.stoves.filter(s => s.area === 'CHEF' && s.facilityStatus === 'active');
    },
    // 扩建动态（预告中/建设中；config 对玩家不可见）
    extensionRows() {
      if (!this.detail || !this.detail.group) {
        return [];
      }
      return this.detail.group.filter(g => g.status === 'announced' || g.status === 'building');
    }
  },
  watch: {
    kitchenVisible: {
      // immediate：组件由 showKitchenDiv v-if 首挂时 kitchenVisible 已为 true，
      // 普通 watch 只在"变化"时触发、首挂不执行，导致 detail 永不加载。加 immediate 让打开即加载。
      immediate: true,
      handler(val) {
        if (val) {
          this.loadDetail();
        } else {
          this.stopStoveTimer();
        }
      }
    }
  },
  beforeDestroy() {
    this.stopStoveTimer();
  },
  methods: {
    loadDetail() {
      this.loading = true;
      getRequest('/facility/facility/detail', { facilityKey: this.facilityKey }).then(resp => {
        if (resp && resp.status === 200 && resp.data && resp.data.status === 200) {
          this.detail = resp.data.data;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
      // 建设者名录（组内合并；物资仅用于排序，不展示明细）
      getRequest('/facility/facility/builders', { facilityKey: this.facilityKey }).then(resp => {
        if (resp && resp.status === 200 && resp.data && resp.data.status === 200) {
          this.contributors = resp.data.data || [];
        }
      });
      this.loadStoves();
      this.startStoveTimer();
    },
    // 灶位列表（占用三字段：烹饪内容/制作人/剩余时间；读路径服务端先结算）
    loadStoves() {
      getRequest('/facility/facility/stove/list', { facilityKey: this.facilityKey }).then(resp => {
        if (resp && resp.data && resp.data.status === 200) {
          this.stoves = resp.data.data || [];
        }
      }).catch(() => {});
    },
    startStoveTimer() {
      this.stopStoveTimer();
      // 每 1.5s 轮询服务端权威倒计时（占用/领取窗），处理后台/切页漂移
      this.stoveTimer = setInterval(() => {
        this.loadStoves();
      }, 1500);
    },
    stopStoveTimer() {
      if (this.stoveTimer) {
        clearInterval(this.stoveTimer);
        this.stoveTimer = null;
      }
    },
    doBuildContribute(r, facilityKey) {
      const params = { facilityKey: facilityKey || this.facilityKey };
      if (r.reqType === 'MATERIAL') {
        const num = this.contributeNum[r.id];
        if (!num || num <= 0) {
          Message.warning('请输入投料数量');
          return;
        }
        params.itemId = r.itemId;
        params.num = num;
      } else {
        const amount = facilityKey && facilityKey !== this.facilityKey
          ? this.extMoneyInput[facilityKey] : this.moneyInput;
        if (!amount || amount <= 0) {
          Message.warning('请输入投料金额');
          return;
        }
        params.moneyAmount = amount;
      }
      postRequest('/facility/facility/buildContribute', params).then(resp => {
        onResult(resp, { success: () => { Message.success(resp.data.message); this.loadDetail(); } });
      });
    },
    doRunContribute(itemId) {
      let num = itemId === '120' ? this.runIngotNum : this.runFuelNum;
      if (!num || num <= 0) {
        Message.warning('请输入投料数量');
        return;
      }
      postRequest('/facility/facility/runContribute', {
        facilityKey: this.facilityKey, itemId: itemId, num: num
      }).then(resp => {
        onResult(resp, { success: () => { Message.success(resp.data.message); this.loadDetail(); } });
      });
    },
    // 选灶下锅（空闲灶按钮；同灶双占后端拦截）
    doCook(stove) {
      if (!this.selectedDish) {
        Message.warning('先在下方选择菜谱');
        return;
      }
      postRequest('/facility/facility/cook', {
        facilityKey: this.facilityKey,
        dishId: this.selectedDish.id,
        fuelSource: this.fuelSource,
        stoveId: stove.id
      }).then(resp => {
        onResult(resp, {
          success: () => {
            Message.success(resp.data.message);
            this.$store.dispatch('user/fetchUserDetail');
            this.$root.eventHub.$emit('buffRefresh');
            this.loadDetail();
            this.loadStoves();
          }
        });
      });
    },
    // 领取窗领取（60 秒内本人；超时产出已转拾取筐）
    doCollect(stove) {
      postRequest('/facility/facility/stove/collect', {
        facilityKey: this.facilityKey,
        stoveId: stove.id
      }).then(resp => {
        onResult(resp, {
          success: () => {
            Message.success(resp.data.message);
            this.$store.dispatch('user/fetchUserDetail');
            this.$root.eventHub.$emit('buffRefresh');
            this.loadDetail();
            this.loadStoves();
          }
        });
      });
    },
    // 我的拾取（拾取筐列表）
    openClaims() {
      getRequest('/facility/facility/claim/list', { facilityKey: this.facilityKey }).then(resp => {
        if (resp && resp.status === 200 && resp.data && resp.data.status === 200) {
          this.claims = resp.data.data || [];
          this.claimsVisible = true;
        }
      });
    },
    doTakeClaim(claim) {
      postRequest('/facility/facility/claim/take', {
        facilityKey: this.facilityKey,
        claimId: claim.id
      }).then(resp => {
        onResult(resp, {
          success: () => {
            Message.success(resp.data.message);
            this.$store.dispatch('user/fetchUserDetail');
            this.openClaims();
            this.loadDetail();
          }
        });
      });
    },
    unlockPercent(ext) {
      if (!ext.unlockTarget) {
        return 0;
      }
      return Math.min(100, Math.floor(((this.detail.opsCookTotal || 0) / ext.unlockTarget) * 100));
    },
    poolPercent(p) {
      if (!p.capacity) {
        return 0;
      }
      return Math.min(100, Math.floor((p.curNum / p.capacity) * 100));
    },
    poolLabel(key) {
      return { FUEL: '燃料池', DURABILITY: '灶具耐久池' }[key] || key + '池';
    },
    materialText(dish) {
      if (!dish || !dish.itemMaterials || !dish.itemMaterials.length) {
        return '';
      }
      return dish.itemMaterials.map(m => m.name + '×' + m.count).join('、');
    },
    fmtNum(v) {
      const n = Number(v);
      return isNaN(n) ? v : (n >= 10000 ? (n / 10000).toFixed(1) + '万' : n);
    },
    fmtTime(ts) {
      const n = Number(ts);
      if (isNaN(n)) {
        return String(ts || '');
      }
      const d = new Date(n);
      const pad = x => (x < 10 ? '0' + x : x);
      return (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    kitchen_dialog_close() {
      this.stopStoveTimer();
      this.$emit('kitchen_dialog_close');
    }
  }
};
</script>

<style scoped>
.wrap >>> .el-dialog { width: 560px; max-width: 94vw; }
.kitchen-build, .kitchen-active { padding: 4px 2px; }
.section-title { font-size: 13px; color: #666; display: block; margin-bottom: 6px; }
.builders-entry { border-top: 1px dashed #eee; margin-top: 10px; padding-top: 8px; }
.builder-row { display: flex; align-items: center; gap: 8px; padding: 3px 0; font-size: 13px; }
.builder-rank { width: 18px; height: 18px; line-height: 18px; text-align: center; border-radius: 50%; background: #f0f0f0; color: #888; font-size: 12px; }
.builder-name { flex: 1; color: #333; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.builder-times { color: #999; font-size: 12px; white-space: nowrap; }
.cook-cd { font-size: 14px; color: #f56c6c; font-weight: 600; margin: 0 2px; }
.build-banner {
  background: #fff7e6; border: 1px solid #f5dab5; color: #d48806;
  padding: 8px 12px; border-radius: 6px; margin-bottom: 12px; font-size: 13px;
}
.progress-row { display: flex; align-items: center; margin-bottom: 4px; }
.progress-label { font-size: 13px; color: #666; margin-right: 10px; white-space: nowrap; }
.tiny-progress { font-size: 12px; color: #999; margin: 4px 0 10px; }
.require-list .require-row {
  display: flex; align-items: center; gap: 8px; padding: 6px 0;
  border-bottom: 1px dashed #eee; flex-wrap: wrap;
}
.require-name { font-size: 14px; min-width: 52px; }
.require-num { font-size: 13px; color: #666; min-width: 90px; }
.require-tag { font-size: 12px; color: #409eff; }
.require-done { font-size: 12px; color: #67c23a; }
.require-input { margin-left: auto; display: flex; gap: 6px; }
.builders-line { font-size: 12px; color: #999; margin-top: 10px; }
.npc-tip { font-size: 12px; color: #999; margin-top: 4px; }
.qualify-banner {
  padding: 8px 12px; border-radius: 6px; margin-bottom: 12px; font-size: 13px;
  background: #fef0f0; color: #f56c6c; border: 1px solid #fbe6e6;
}
.qualify-banner.ok { background: #f0f9eb; color: #67c23a; border-color: #e1f3d8; }
.pool-row { display: flex; align-items: center; gap: 8px; margin: 8px 0; }
.pool-name { font-size: 13px; color: #666; white-space: nowrap; width: 88px; }
.pool-num { font-size: 12px; color: #999; white-space: nowrap; }
.pool-tip { font-size: 12px; color: #999; margin-bottom: 6px; }
.section-title { font-size: 13px; font-weight: bold; color: #606266; display: block; margin: 8px 0 6px; }
.contribute-row { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
/* 灶位区 */
.stove-area, .chef-area, .ext-area { margin-top: 6px; }
.stove-row {
  display: flex; align-items: center; gap: 8px; padding: 5px 8px; margin: 4px 0;
  border: 1px solid #eee; border-radius: 6px; background: #fafafa; font-size: 13px; flex-wrap: wrap;
}
.stove-row.mine { border-color: #67c23a; background: #f0f9eb; }
.stove-name { min-width: 150px; color: #606266; font-weight: bold; }
.stove-state { flex: 1; color: #909399; }
.stove-tip { font-size: 12px; color: #999; }
.my-claims-entry { margin-top: 8px; }
.claim-row { display: flex; align-items: center; gap: 8px; padding: 5px 0; border-bottom: 1px dashed #eee; font-size: 13px; }
.claim-name { flex: 1; }
.claim-time { color: #999; font-size: 12px; }
/* 菜谱 */
.cook-area { margin-top: 6px; }
.dish-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.dish-card {
  width: 160px; border: 1px solid #eee; border-radius: 6px; padding: 8px 10px;
  cursor: pointer; background: #fafafa;
}
.dish-card.active { border-color: #409eff; background: #ecf5ff; }
.dish-name { font-size: 14px; font-weight: bold; margin-bottom: 2px; }
.dish-effect { font-size: 12px; color: #67c23a; }
.dish-mat { font-size: 12px; color: #999; }
/* 扩建 */
.ext-block { border: 1px dashed #dcdfe6; border-radius: 6px; padding: 8px 10px; margin: 6px 0; }
.ext-title { font-size: 13px; font-weight: bold; color: #606266; margin-bottom: 4px; }
.buff-tip { font-size: 12px; color: #999; margin-top: 10px; }
.empty-tip { text-align: center; color: #999; padding: 20px 0; }
@media (max-width: 768px) {
  .wrap >>> .el-dialog { width: 94vw; }
  .dish-card { width: 45%; }
  .require-input { margin-left: 0; width: 100%; }
  .stove-name { min-width: 120px; }
}
</style>
